module.exports = __webpack_public_path__ + "static/img/jjc_first.de8bd6cc.png";